const cache = new Map();
/** "a, b e c" (pt-BR) / "a, b, and c" (en-US). Replaces A2's `joinPt`. */
export function joinList(items, locale) {
    let format = cache.get(locale);
    if (!format) {
        format = new Intl.ListFormat(locale, {
            style: "long",
            type: "conjunction",
        });
        cache.set(locale, format);
    }
    return format.format(items);
}
//# sourceMappingURL=list.js.map